// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1708":"ee26af753d36ec76","6793":"f57464ca23fa9330"}[chunkId] + ".js";
};